<script>
	import { onMount } from 'svelte';
	import { userid } from './utils';

	import ConfigEdit from './routes/ConfigEdit.svelte';
	import Clients from './routes/Clients.svelte';
	import ClientConfigs from './routes/ClientConfigs.svelte';

	// import { NotificationDisplay } from '@shopboxai/sb-portal-components';

	export let user = {};
	let mounted = false;

	const routingMap = {
		'#edit': ConfigEdit,
		'#configs': ClientConfigs,
		'#list': Clients
	};

	let page;

	function routeChange() {
		let hash = location.hash.split('?')[0];
		page = routingMap[hash] || Clients;
	}
	onMount(() => {
		$userid = user;
		mounted = true;

		routeChange();
	});
	$: if (window.location.hash) {
		routeChange();
	}
</script>

<svelte:window on:popstate={routeChange} on:hashchange={routeChange} />
{#if mounted}
	<main>
		<!-- <NotificationDisplay /> -->
		<div class="app-container">
			<svelte:component this={page} />
		</div>
	</main>
{/if}

<style>
	/* Standart styles accross portal apps */

	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
		margin: 0;
		padding: 0;
	}

	main {
		width: 100%;
		position: relative;
	}

	:global(:is(h1, h2)) {
		color: #000;
		font-family: 'Chivo', sans-serif;
	}
	:global(:is(h1)) {
		font-weight: 900;
	}

	:global(header) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em 0;
		border-bottom: 1px solid #dadada;
		margin-bottom: 1em;
	}
</style>
